import { LogoMark } from "./LogoMarks";

export const Logo = ({ light = false, mark = "heart-home", size = 38 }) => (
  <span className="flex items-center gap-3">
    <LogoMark mark={mark} light={light} size={size} />
    <span className="leading-tight">
      <span className={`block font-display text-lg font-semibold ${light ? "text-[#FAF8F5]" : "text-[#1E3A2B]"}`}>Friendship Pen</span>
      <span className={`block text-[10px] uppercase tracking-[0.24em] font-semibold ${light ? "text-[#E5E0D8]" : "text-[#5A6561]"}`}>Care Services</span>
    </span>
  </span>
);
